import * as d3 from 'd3';
import i18n from 'i18n/config';

const getBrowserLocale = (lang) => {
  switch (lang) {
    case 'de':
      return 'de-DE';
    case 'fr':
      return 'fr-FR';
    case 'es':
      return 'es-ES';
    case 'ja':
      return 'ja-JP';
    case 'en':
    default:
      return 'en-US';
  }
};

// Formats Date ticks on time-based x-axes using the current i18n language.
export const formatTimeTick = (d) => {
  if (!(d instanceof Date)) return d;
  const lang = i18n.language || 'en';
  const locale = getBrowserLocale(lang);
  try {
    // Short month + day (e.g. "9 Mar"), localized per language.
    return d.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
  } catch (e) {
    return d.toLocaleDateString();
  }
};

// append horizontal grid lines (they start from the yAxis)
// ticks are the text + a line that are generally marking chart data lines
// tickFormat '' is a way to not apply any text to the ticks (draw only lines)
// setting the tickSize to the node width we can draw a grid

export const yAxisGridlines = (node, scale, ticks, chartName) =>
  d3.select(node)
    .append('g')
    .attr('class', `${chartName} axis axis--y`)
    .call(d3.axisRight(scale)
      .ticks(ticks)
      .tickSize(node.getBoundingClientRect().width)
      .tickFormat(''));

// same as y axis but on the vertical side
// need to transform the origin by height so that it is beginning from the bottom
export const xAxisGridlines = (node, scale, ticks, chartName) =>
  d3.select(node)
    .append('g')
    .attr('transform', `translate(0, ${node.getBoundingClientRect().height})`)
    .attr('class', `${chartName} axis axis--x`)
    .call(d3.axisTop(scale)
      .ticks(ticks)
      .tickSize(node.getBoundingClientRect().height)
      .tickFormat(''));

// these will display the text since they have unmodified tickFormat,
// class tickline-hidden enables the possibility to hide overlapping ticks if desired
export const ticksBottom = (
  node,
  scale,
  ticks,
  chartName,
  translateY = node.getBoundingClientRect().height
) =>
  {
    let axis = d3.axisBottom(scale)
      .ticks(ticks);

    // If this is a time scale (ticks are Dates), localize the labels.
    const sampleTicks = typeof scale.ticks === 'function' ? scale.ticks(1) : [];
    if (sampleTicks.length && sampleTicks[0] instanceof Date) {
      axis = axis.tickFormat(formatTimeTick);
    }

    return d3.select(node)
      .append('g')
      .attr('transform', `translate(0, ${translateY})`)
      .attr('class', `${chartName} axis tickline-hidden`)
      .call(axis);
  }

export const ticksLeft = (node, scale, ticks, chartName) =>
  d3.select(node)
    .append('g')
    .attr('class', `${chartName} axis tickline-hidden ticks-left`)
    .call(d3.axisLeft(scale)
      .ticks(ticks)
      .tickSize(10));
